import { toaster, ToastPropsShape } from "baseui/toast";

const defaultNotificationOptions: ToastPropsShape = {
  autoHideDuration: 3000,
  closeable: true,
  notificationType: "inline",
};
export const NotificationService = {
  success: (message: string, options?: ToastPropsShape): void => {
    toaster.positive(message, { ...defaultNotificationOptions, ...options });
  },

  error: (message: string, options?: ToastPropsShape): void => {
    toaster.negative(message, {
      ...defaultNotificationOptions,
      ...options,
    });
  },

  info: (message: string, options?: ToastPropsShape): void => {
    toaster.info(message, {
      ...defaultNotificationOptions,
      ...options,
    });
  },

  warning: (message: string, options?: ToastPropsShape): void => {
    toaster.warning(message, {
      ...defaultNotificationOptions,
      ...options,
    });
  },
};
